import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import * as errorsActions from './reducer';

import './Errors.css';

export class ErrorsComponent extends Component {
  static get propTypes() {
    return {
      errors: PropTypes.arrayOf(PropTypes.shape()),
      onClear: PropTypes.func.isRequired
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };
  }

  render() {
    const { errors } = this.props;

    return errors && errors.length > 0
      ? this.renderErrors()
      : null;
  }

  renderErrors() {
    const { errors, onClear } = this.props;
    const { expanded } = this.state;

    return (<div className="Errors-overlay">
      <div className="Errors-popup">
        <h1>{errors.length === 1 ? 'An error occurred' : 'Errors occurred'}</h1>
        <ul className="Errors-first">
          {this.renderError(errors[0], 0)}
        </ul>
        {errors.length > 1 && <div className="Errors-more">
          <button
            className="btn"
            onClick={() => this.setState({ expanded: !expanded })}
          >
            {expanded ? 'hide' : 'show'}
          </button>
          {(errors.length - 1)} more error{errors.length !== 2 ? 's' : ''}
        </div>}
        { expanded && <ul className="Errors-others">
          {errors.map((err, index) => index !== 0 && this.renderError(err, index))}
        </ul>}
        <div className="Errors-footer">
          <button className="btn btn-primary clear-errors" onClick={onClear}>OK</button>
        </div>
      </div>
    </div>);
  }

  renderError(error, index) {
    const lines = error.message.split(/\n/);
    return (<li className="Errors-error" key={`error-${index}`}>
      {lines.map(l => <span className="Errors-message">{l}</span>)}
      {error.context && <span className="Errors-context">{error.context}</span>}
    </li>);
  }
}

const mapStateToProps = state => ({
  ...state.errors
});

const mapDispatchToProps = (dispatch) => {
  const {
    clearErrors
  } = bindActionCreators(errorsActions, dispatch);

  return {
    onClear: clearErrors
  };
};

const Errors = withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ErrorsComponent));
export default Errors;



// WEBPACK FOOTER //
// ./src/errors/Errors.js